
/* eslint-disable no-magic-numbers */

const deprecate = require('util-deprecate');

const _ = require('lodash');

const WHOLE = 1e15;
const REGION = 1e13;
const DISTRICT = 1e10;
const CITY = 1e7;
const SETTLEMENT = 1e4;
const STREET = 1;

const ordering = [
	WHOLE,
	REGION,
	DISTRICT,
	CITY,
	SETTLEMENT,
	STREET,
];

function before (x) {
	return ordering[ordering.indexOf(x) - 1] || WHOLE;
}

function after (x) {
	return ordering[ordering.indexOf(x) + 1] || 0;
}


const K = {
	REGION: REGION,
	DISTRICT: DISTRICT,
	CITY: CITY,
	SETTLEMENT: SETTLEMENT,
	STREET: STREET,

	round: function (k, m) {
		return (Math.floor(k / m) * m) || 0;
	},

	erase: function (k, m) {
		return k - (k - K.round(k, before(m)));
	},

	slice: function (k, m) {
		const sliceEnd = Math.round(-Math.log(m) / Math.log(10));
		const str = (k || 0).toString();
		return parseInt(str.slice(0, sliceEnd === 0 ? str.length : sliceEnd)) || 0;
	},

	unslice: function (code, m) {
		return code * m;
	},

	accuracy: function (k) {
		let a = k ? 1 : 0;
		while (k && !(k % 10)) {
			a = a * 10;
			k = Math.round(k / 10);
		}
		return after(_.findLast(ordering, (v) => v > a));
	},

	mostAccurate: function (ks) {
		return _.maxBy(ks, (k) => k ? (0 - K.accuracy(k)) : -Infinity);
	},

	leastAccurate: function (ks) {
		return _.minBy(ks, (k) => k ? (0 - K.accuracy(k)) : Infinity);
	},

	_wrongContains: deprecate(
		function (m, k1, k2) {
			return this.round(k1, m) === this.round(k2, m);
		},
		"`contains` with 3 arguments is depricated"
			+ " (turns out, it does not make sence in KLADR),"
			+ " use 2-arguments version"
	),

	contains: function (haysack, needle) {
		if (arguments.length === 3) {
			return this._wrongContains(...arguments);
		}
		const haysackAccuracy = this.accuracy(haysack);
		return this.round(haysack, haysackAccuracy) === this.round(needle, haysackAccuracy);
	},

	is: function (k, m) {
		return k !== K.round(k, before(m));
	},

	convertKladrToNumber: (kladr) => {
		return _.toNumber(`${kladr}00`);
	},
};


module.exports = K;

